import { SignedOut, SignIn, SignUp, useUser } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";
import { PAGES } from "../constants/pages";

const RegisterPage = () => {
  const { isSignedIn } = useUser();

  if (isSignedIn) {
    return <Navigate to={PAGES.DASHBOARD} />;
  }

  return (
    <SignedOut>
      <div className="h-screen w-screen flex justify-center items-center">
        <SignUp />
      </div>
    </SignedOut>
  );
};

export default RegisterPage;
